"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "leivi": {
    "0728b367": [{
      "hkey": "b1b3294f",
      "slug": "aigo-crocetta-san-rufino",
      "name": "Aigo-Crocetta-San Rufino",
      "primary": true,
      "skipSearch": false
    }],
    "aigo": [{
      "hkey": "b1b3294f",
      "slug": "aigo-crocetta-san-rufino",
      "name": "Aigo-Crocetta-San Rufino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8cec4e4a": [{
      "hkey": "3188a588",
      "slug": "bocco-san-lorenzo",
      "name": "Bocco-San Lorenzo",
      "primary": true,
      "skipSearch": false
    }],
    "bocco": [{
      "hkey": "3188a588",
      "slug": "bocco-san-lorenzo",
      "name": "Bocco-San Lorenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5bc217bd": [{
      "hkey": "2af3087b",
      "slug": "mongiardino",
      "name": "Mongiardino",
      "primary": true,
      "skipSearch": false
    }],
    "comune-mongiardino": [{
      "hkey": "2af3087b",
      "slug": "mongiardino",
      "name": "Mongiardino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fece3e03": [{
      "hkey": "b1b3294f",
      "slug": "aigo-crocetta-san-rufino",
      "name": "Aigo-Crocetta-San Rufino",
      "primary": true,
      "skipSearch": false
    }],
    "crocetta": [{
      "hkey": "b1b3294f",
      "slug": "aigo-crocetta-san-rufino",
      "name": "Aigo-Crocetta-San Rufino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "leivi"
    }],
    "54004d0f": [{
      "hkey": "92c46259",
      "slug": "comune-solaro",
      "name": "Comune-Solaro",
      "primary": true,
      "skipSearch": false
    }],
    "solaro": [{
      "hkey": "92c46259",
      "slug": "comune-solaro",
      "name": "Comune-Solaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;